<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <p>Total Devotional Completions: {{ completions.length }}</p>
        <template v-if="rank !== null">
          <v-flex xs12>
            <p>Current Rank: {{ rank.title }}</p>
            <template v-if="rankNext !== null">
              <p>Next Rank: {{ rankNext.title }} ({{ rankNext.requirement - this.completions.length }} more)</p>
              <v-progress-linear
                :value="(completions.length - rank.requirement) / (rankNext.requirement - rank.requirement) * 100"
              />
            </template>
          </v-flex>
        </template>
        <p v-if="streak.days > 0">Streak: {{ streak.days }} days (since {{ streak.start }}){{ !isCompletedToday ? ' - Complete today to continue!' : '' }}</p>
        <p v-else>Complete today's devotional to start a streak!</p>
        <p v-if="longestStreak.days > 0">Longest Streak: {{ longestStreak.days }} days ({{ longestStreak.start }} - {{ longestStreak.end }})</p>
      </v-flex>
      <v-flex xs4 text-xs-center>
        <v-progress-circular
          :value="$root.devotionalCompletionsInWeek / 7 * 100"
          size="60"
          color="primary"
        >
          {{ $root.devotionalCompletionsInWeek }}/7
        </v-progress-circular>
        <p>Week</p>
      </v-flex>
      <v-flex xs4 text-xs-center>
        <v-progress-circular
          :value="$root.devotionalCompletionsInMonth / daysInMonth * 100"
          size="60"
          color="primary"
        >
          {{ $root.devotionalCompletionsInMonth }}/{{ daysInMonth }}
        </v-progress-circular>
        <p>Month</p>
      </v-flex>
      <v-flex xs4 text-xs-center>
        <v-progress-circular
          :value="$root.devotionalCompletionsInYear / daysInYear * 100"
          size="60"
          color="primary"
        >
          {{ $root.devotionalCompletionsInYear }}/{{ daysInYear }}
        </v-progress-circular>
        <p>Year</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const { DateTime } = require('luxon')
export default {
  data: () => ({
    ranks: []
  }),
  computed: {
    daysInMonth: function () {
      return DateTime.local().daysInMonth
    },
    daysInYear: function () {
      return DateTime.local().daysInYear
    },
    completions: function () {
      // Sort our completions by date, newest first
      return this.$root.devotionalCompletions.slice().sort((a, b) => {
        if (a.created_at < b.created_at) {
          return 1
        }
        if (a.created_at > b.created_at) {
          return -1
        }
        return 0
      })
    },
    isCompletedToday: function () {
      // If we have no completions, there's nothing to check
      if (this.completions.length === 0) {
        return false
      }

      // See if the most recent completion was completed today
      let now = DateTime.local().startOf('day').valueOf()
      let recent = DateTime.fromSQL(this.completions[0].created_at, { zone: 'UTC' })
        .setZone('America/Chicago') // XXX: Time zone should be configurable
        .startOf('day')
        .valueOf()

      return now === recent
    },
    streaks: function () {
      let s = []

      let counter = 0
      let previous = DateTime.local().startOf('day')
      let end = previous
      for (let i = 0; i < this.completions.length; i++) {
        let c = this.completions[i]
        let d = DateTime.fromSQL(c.created_at, { zone: 'UTC' })
          .setZone('America/Chicago') // XXX: Time zone should be configurable
          .startOf('day')
        let { days } = previous.diff(d, 'day').toObject()

        // If this day is contiguous with the previous one, add to our streak counter
        if (days <= 1) {
          counter++
        }

        // If this day is not contiguous with the previous one, or if this is
        // the oldest completion we have on record, then finish up the streak
        if (days > 1 || i === (this.completions.length - 1)) {
          // The case of "last iteration" requires us to set our "previous" date
          // value sooner than normal for it to be used as the streak start date
          if (i === (this.completions.length - 1)) {
            previous = d
          }

          // Add the streak information to our list
          s.push({
            days: counter,
            start: previous.toLocaleString(),
            end: end.toLocaleString()
          })

          // Reset
          counter = 1
          end = d
        }

        // Prepare for next iteration
        previous = d
      }
      return s
    },
    rankIndex: function () {
      let index = -1

      for (let i = 0; i < this.ranks.length; i++) {
        // Store this rank if we meet its requirement, or be done if we don't
        if (this.completions.length >= this.ranks[i].requirement) {
          index = i
        } else {
          break
        }
      }

      return index
    },
    rank: function () {
      if (this.rankIndex === -1) {
        return null
      } else {
        return this.ranks[this.rankIndex]
      }
    },
    rankNext: function () {
      if (this.rankIndex === -1 || (this.rankIndex + 1) >= this.ranks.length) {
        return null
      } else {
        return this.ranks[this.rankIndex + 1]
      }
    },
    streak: function () {
      // The first of our streaks will be the current one. There should always
      // be a value, but we check just in case
      if (this.streaks.length > 0) {
        return this.streaks[0]
      } else {
        return { days: 0 }
      }
    },
    longestStreak: function () {
      return this.streaks.reduce((prev, streak) => {
        if (streak.days > prev.days) {
          return streak
        } else {
          return prev
        }
      }, { days: -1 })
    }
  },
  mounted: function () {
    // Make sure our completion data is up to date
    this.$root.updateDevotionalCompletions()

    // Retrieve information about completion ranks
    this.axios.get('/devotionals/completions/ranks')
      .then((res) => {
        this.ranks = res.data
      })
      .catch(this.$root.apiErrorHandler())
  }
}
</script>
